import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/register-stripe-screen';
import { useAuth } from '@fans-fund-me/shared-common-esm-authentication';
import { useEffect, useState } from 'react';
import { createStripeAccount } from '../../api/payments.ts';
import { stripeQueueStatus } from '../../api/profile.ts';

function RegisterStripe() {
  const auth = useAuth();

  const [isLoading, setIsLoading] = useState(false);
  const [isSetupLoading, setIsSetupLoading] = useState(false);
  const [inQueue, setInQueue] = useState(false);
  const [queuePlace, setQueuePlace] = useState(100);

  const handleClick = () => {
    setIsSetupLoading(true);
    createStripeAccount(auth.token, {
      refreshUrl: `${import.meta.env.VITE_STRIPE_REDIRECT}/${auth.details.username}`,
      returnUrl: `${import.meta.env.VITE_STRIPE_REDIRECT}/${auth.details.username}`,
    })
      .then((response) => {
        setIsSetupLoading(false);
        location.href = response.data.url;
      })
      .catch((error) => {
        console.error('Error sending user to Stripe', JSON.stringify(error));
        setIsSetupLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    stripeQueueStatus(auth.token).then((response) => {
      setIsLoading(false);
      setInQueue(response.data.type === 'QUEUED');
      setQueuePlace(response.data.queuePosition);
    });
  }, []);

  return (
    <Screen
      handleClick={handleClick}
      isLoading={isLoading}
      isSetupLoading={isSetupLoading}
      inQueue={inQueue}
      queuePlace={queuePlace}
    />
  );
}

export default RegisterStripe;
